"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var content_accessor_1 = require("../content-accessor");

var string_1 = require("../../util/string");

var asset_accessor_1 = require("../asset-accessor");

var contentful_asset_accessor_1 = require("./contentful-asset-accessor");

var contentful_image_accessor_1 = require("./contentful-image-accessor");

var image_accessor_1 = require("../image-accessor");

var lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));

var ContentfulContentAccessor =
/** @class */
function () {
  function ContentfulContentAccessor(base) {
    this.base = base;
  }

  ContentfulContentAccessor.prototype.accessBaseFor = function (fieldName) {
    var _a, _b;

    return (_b = (_a = this.base) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b[fieldName];
  };

  ContentfulContentAccessor.prototype.raw = function () {
    var _a;

    return lodash_clonedeep_1["default"]((_a = this.base) === null || _a === void 0 ? void 0 : _a.fields);
  };

  ContentfulContentAccessor.prototype.field = function (fieldName) {
    return this.accessBaseFor(fieldName) ? new ContentfulContentAccessor(this.accessBaseFor(fieldName)) : new content_accessor_1.NullAccessor();
  };

  ContentfulContentAccessor.prototype.array = function (fieldName) {
    var _a;

    return (_a = this.accessBaseFor(fieldName), _a !== null && _a !== void 0 ? _a : []).map(function (v) {
      return new ContentfulContentAccessor(v);
    });
  };

  ContentfulContentAccessor.prototype.object = function (fieldName, defaultValue) {
    var _a;

    return _a = this.accessBaseFor(fieldName), _a !== null && _a !== void 0 ? _a : defaultValue;
  };

  ContentfulContentAccessor.prototype.text = function (fieldName, defaultValue) {
    var _a;

    return _a = this.accessBaseFor(fieldName), _a !== null && _a !== void 0 ? _a : defaultValue;
  };

  ContentfulContentAccessor.prototype.longText = function (fieldName, defaultValue) {
    var _a;

    return _a = this.accessBaseFor(fieldName), _a !== null && _a !== void 0 ? _a : defaultValue;
  };

  ContentfulContentAccessor.prototype.richText = function (fieldName, defaultValue) {
    var _a;

    return _a = this.accessBaseFor(fieldName), _a !== null && _a !== void 0 ? _a : defaultValue;
  };

  ContentfulContentAccessor.prototype.slug = function (fieldName, defaultValue) {
    return this.accessBaseFor(fieldName) ? string_1.slugify(this.accessBaseFor(fieldName)) : defaultValue;
  };

  ContentfulContentAccessor.prototype.number = function (fieldName, defaultValue) {
    var _a;

    return _a = this.accessBaseFor(fieldName), _a !== null && _a !== void 0 ? _a : defaultValue;
  };

  ContentfulContentAccessor.prototype["boolean"] = function (fieldName, defaultValue) {
    var _a;

    return _a = this.accessBaseFor(fieldName), _a !== null && _a !== void 0 ? _a : defaultValue;
  };

  ContentfulContentAccessor.prototype.asset = function (fieldName) {
    return this.accessBaseFor(fieldName) ? new contentful_asset_accessor_1.ContentfulAssetAccessor(this.accessBaseFor(fieldName)) : new asset_accessor_1.NullAssetAccessor();
  };

  ContentfulContentAccessor.prototype.image = function (fieldName) {
    return this.accessBaseFor(fieldName) ? new contentful_image_accessor_1.ContentfulImageAccessor(this.accessBaseFor(fieldName)) : new image_accessor_1.NullImageAccessor();
  };

  ContentfulContentAccessor.prototype.type = function () {
    var _a, _b, _c;

    if (!this.base) {
      return asset_accessor_1.CommonAccessorType.UNDEFINED;
    }

    var contentTypeId = (_c = (_b = (_a = this.base.sys) === null || _a === void 0 ? void 0 : _a.contentType) === null || _b === void 0 ? void 0 : _b.sys) === null || _c === void 0 ? void 0 : _c.id;

    if (contentTypeId) {
      return "Contentful" + string_1.capitalize(contentTypeId);
    }

    console.error("ContentfulContentAccessor: type() requested on a entry sys.contentType.sys.id");
    return asset_accessor_1.CommonAccessorType.UNKNOWN;
  };

  ContentfulContentAccessor.prototype.file = function (fieldName) {
    return new asset_accessor_1.NullFileAccessor();
  };

  return ContentfulContentAccessor;
}();

exports.ContentfulContentAccessor = ContentfulContentAccessor;